import * as React from 'react'

import PropTypes from 'prop-types'

import Input from './components/Input'
import Textarea from './components/Textarea'
import Select from './components/Select'
import Checkbox from './components/Checkbox'
import Editor from './components/editor'
import Label from './components/Label'
import Errormessage from './components/Errormessage'
import Radio from './components/Radio'
import DatePicker from './components/DatePicker'

const Form = ({ onSubmit, children }) => (
  <form className="form" onSubmit={onSubmit}>
    {children}
  </form>
)

Form.propTypes = {
  onSubmit: PropTypes.func,
  children: PropTypes.node,
}

export { Input, Textarea, Select, Checkbox, Editor, Errormessage, Label, Radio, DatePicker }

export default Form
